<div class="flex">
  <h2 class="mx-auto text-3xl text-gray-700 font-semibold">Passwort vergessen</h2>
</div>
<div class="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
  <!-- Which of the two account kinds this run is for. Named on the screen because the person cannot tell from
       the URL, and landing on the wrong one produces no mail and no explanation. -->
  <p class="mb-6 text-sm text-gray-600">
    @if (isAccount) {
      Für Ihr <span class="font-semibold">CheqMe-Konto</span> mit E-Mail-Adresse und Passwort. Geben Sie die
      E-Mail-Adresse an, mit der Sie sich anmelden.
    } @else {
      Für ein <span class="font-semibold">bestehendes Konto</span> (Mitarbeiterzugang). Geben Sie die
      E-Mail-Adresse an, die für Sie hinterlegt ist.
    }
  </p>

  <form class="space-y-6" action="#" method="POST">
    <div>
      <label for="email" class="block text-sm font-medium leading-6 text-gray-900">E-Mail-Adresse</label>
      <div class="mt-2">
        <input id="email" name="email" type="email" autocomplete="email" required [(ngModel)]="email"
               class="px-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6">
      </div>
    </div>

    <div>
      <button type="submit" (click)="reset()"
              class="bg-theme-primary-700 hover:bg-theme-primary-900 flex w-full justify-center rounded-md px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2">
        E-Mail anfordern
      </button>
    </div>

    <!-- The second factor is deliberately NOT reset with the password (see native-accounts.md). Saying so here
         costs one line and saves the support call from somebody who assumed a reset was a full recovery. -->
    @if (isAccount) {
      <p class="text-xs text-gray-500">
        Ein neues Passwort ersetzt nur das Passwort. Ist für Ihr Konto eine Zwei-Faktor-Authentifizierung
        eingerichtet, wird sie danach weiterhin abgefragt — nutzen Sie dafür Ihren Wiederherstellungscode.
      </p>
    }
  </form>
</div>
